import React, { useState, useRef } from "react";
import { ACTIVE_NETWORK } from "../../config/app.config";

// Shows a contract's deployed address with a copy button + explorer link.
export default function AddressBar({ label, address }) {
  const [copied, setCopied] = useState(false);
  const timer = useRef(null);

  const valid = address && /^0x[a-fA-F0-9]{40}$/.test(address) && address !== "0x0000000000000000000000000000000000000000";

  const copy = async () => {
    if (!valid) return;
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(address);
      } else {
        const ta = document.createElement("textarea");
        ta.value = address; ta.style.position = "fixed"; ta.style.opacity = "0";
        document.body.appendChild(ta); ta.focus(); ta.select();
        document.execCommand("copy"); document.body.removeChild(ta);
      }
      setCopied(true);
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(() => setCopied(false), 1600);
    } catch { /* ignore */ }
  };

  const explorer = ACTIVE_NETWORK.blockExplorerUrls && ACTIVE_NETWORK.blockExplorerUrls[0];

  return (
    <div className="addr-bar">
      <div className="addr-meta">
        <span className="addr-label">{label}</span>
        <span className="addr-value mono">{valid ? address : "Not configured"}</span>
      </div>
      <div className="addr-actions">
        {valid && explorer && (
          <a className="addr-link" href={`${explorer}/address/${address}`} target="_blank" rel="noreferrer">↗</a>
        )}
        <button className={`copy-btn ${copied ? "done" : ""}`} onClick={copy} disabled={!valid}>
          {copied ? "Copied" : "Copy"}
        </button>
      </div>
    </div>
  );
}
